import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentList } from 'projects/Administration/src/app/business-entities/appointmentList-model';
import { WorkOrderHistoryViewModel } from 'projects/Administration/src/app/business-entities/work-order-details-view-model';
import { AppointmentWorkOrderService } from 'projects/Administration/src/app/business-services/appointment-work-order.service';
import { AppointmentService } from 'projects/Administration/src/app/business-services/appointment.service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { VehicleBusinessService } from 'projects/Administration/src/app/business-services/vehicle-service';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { WorkOrderHistoryDetailsComponent } from '../work-order-history-details/work-order-history-details.component';
import { MultiStackPopupService } from 'projects/Administration/src/app/services/multi-stack-popup.service';
@Component({
  selector: 'app-historical-work-orders',
  templateUrl: './historical-work-orders.component.html',
})
export class HistoricalWorkOrdersComponent implements OnInit {
  historicalWorkOrdersList: WorkOrderHistoryViewModel[] = [];
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  totalCount: number = 0;
  throttle = 100;
  scrollDistance = 1;
  LanguageCode: string = "";
  appointmentDetails: AppointmentList[];
  historiyWorkOrdersRequestModel = {
    licensePlateNo: '',
    workOrderNo: '',
    appointmentId: 0,
    excludeAppointmentId: 0,
    StartRecordNumber: 0,
    PageSize: 25,
    sortColumn: "",
    sortDirection: "",
    VINNumber: ""
  };
  constructor(
    private readonly appointmentService: AppointmentService,
    private readonly spinner: NgxSpinnerService,
    private readonly editAppointmentService: EditAppointmentService,
    private readonly vehicleBusinessService: VehicleBusinessService,
    private readonly modalService: NgbModal,
    public workOrderService: AppointmentWorkOrderService,
    private readonly activeModal: NgbActiveModal,
    private readonly cookieservice: CookieService,
    private readonly multiStackPopupService: MultiStackPopupService,
  ) { }

  ngOnInit(): void {
    this.LanguageCode = this.cookieservice.get('userSelectedLanguage');
    if (this.editAppointmentService.isFromVehicleHistoricalTab) {
      this.historiyWorkOrdersRequestModel.licensePlateNo = this.vehicleBusinessService.licensePlate;
      this.historiyWorkOrdersRequestModel.VINNumber = this.vehicleBusinessService.vinNo;
    } else {
      this.historiyWorkOrdersRequestModel.licensePlateNo =
        this.editAppointmentService?.appointmentDetails?.licensePlate;
        this.historiyWorkOrdersRequestModel.VINNumber = this.editAppointmentService?.appointmentDetails?.chassisNo;
        this.historiyWorkOrdersRequestModel.excludeAppointmentId = this.editAppointmentService?.appointmentDetails?.id;
    }
    this.getHistoricalWorkOrders();
  }

  onScrollDown(_ev) {
    if (this.totalCount > this.historicalWorkOrdersList.length) {
      this.historiyWorkOrdersRequestModel.StartRecordNumber = this.historicalWorkOrdersList.length;
      this.getHistoricalWorkOrders();
    }
  }

  //Historical work orders
  getHistoricalWorkOrders() {
    this.spinner.show();
    this.appointmentService
      .GetWorkOrderHistoryForVehicle(this.historiyWorkOrdersRequestModel)
      .then((response) => {
        if (response) {
          this.historicalWorkOrdersList.push(...this.historicalWorkOrderDataMapper(response));
          this.totalCount = this.historicalWorkOrdersList[0].totalCount;
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      });
  }

  //Historical work orders mapper
  historicalWorkOrderDataMapper(woList: any) {
    let supperArray = [];
    if (woList && woList.length > 0) {
      woList.forEach(element => {

        let single = Object();
        single.workOrderNumber = element.workOrderNumber;
        single.status = element.status;
        single.description = element.description;
        single.kilometer = element.kilometer;
        single.customerName = element.customerName;
        single.entryDate = element.entryDate;
        single.workOrderDate = element.workOrderDate;
        single.dealer = element.dealer;
        single.appointmentGuid = element.appointmentGuid;
        single.appointmentid = element.appointmentid;
        single.brandCode = element.brandCode;
        single.totalCount = element.totalCount;
        single.isFromArchive = element.isFromArchive;
        single.reasonForCancellation = element.reasonForCancellation;
        single.reasonForDeletion = element.reasonForDeletion;
        single.isDeleted = element.isDeleted;
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  //Open popUp
  OpenWODetail(woDetail: any): void {
    this.editAppointmentService.isFromHistoricalWOTab = true;
    this.editAppointmentService.appointmentGuidOfSelectedWO =
      woDetail.appointmentGuid;
    this.editAppointmentService.appointmentIdOfSelectedWO =
      woDetail.appointmentid;

    const modalref = this.modalService.open(WorkOrderHistoryDetailsComponent, {
      size: 'lg',
      scrollable: true,
      windowClass: 'pop-wid1366 CustomCardPopup',
    });

    let data = {
      brandLogoPath: woDetail.brandCode,
    };
    modalref.componentInstance.woAppoinment = data;
  }

  async OpenEditView(woDetail: any) {
    this.multiStackPopupService.OpenAppointment(woDetail.appointmentid);
  }

  async onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.historiyWorkOrdersRequestModel.sortColumn = column;
    this.historiyWorkOrdersRequestModel.sortDirection = direction;
    this.historiyWorkOrdersRequestModel.StartRecordNumber = 0;
    this.historicalWorkOrdersList = [];
    this.getHistoricalWorkOrders();
  }
  //Close PopUp
  OnClose() {
    this.activeModal.close({ success: false });
  }

}
